"use client";
import { Button } from "antd";
import { IconArrowNarrowLeft } from "@/lib/icons";
import Link from "next/link";
export default function BackButton() {
  return (
    <Link href="/" title="Back">
      <Button
        icon={<IconArrowNarrowLeft size={16} />}
        color="default"
        variant="filled"
        shape="circle"
        aria-label="Back"
      />
    </Link>
  );
}
